import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Modal.scss";

export function Modal({
  title,
  titleNode,
  beforeTitle,
  afterTitle,
  children,
  contentClassName,
  className,
  disableFullscreen
}) {
  return (
    <div
      className={classNames(
        styles.modal,
        "tw-relative",
        "tw-flex",
        "tw-flex-col",
        "tw-h-max",
        "tw-my-6",
        "tw-mx-4",
        "tw-w-full",
        "tw-min-w-[288px]",
        "tw-max-w-fit",
        "tw-bg-[#ffffff]/80",
        "tw-backdrop-blur-[5px]",
        {
          "tw-rounded-xl": disableFullscreen,
          "lg:tw-rounded-xl": !disableFullscreen,
          [styles.smFullscreen]: !disableFullscreen
        },
        className
      )}
    >
      {(title || beforeTitle || afterTitle) && (
        <div className={classNames("tw-flex", "tw-items-center", "tw-justify-center", "tw-mt-2")}>
          <div className={classNames(styles.beforeTitle)}>{beforeTitle}</div>
          {titleNode ? titleNode : <h5 className="tw-text-lg">{title}</h5>}
          <div className={classNames(styles.afterTitle)}>{afterTitle}</div>
        </div>
      )}
      <div
        className={classNames(
          styles.content,
          "tw-min-h-[160px]",
          { "tw-overflow-auto": !disableFullscreen },
          contentClassName
        )}
      >
        {children}
      </div>
    </div>
  );
}

Modal.propTypes = {
  title: PropTypes.node,
  titleNode: PropTypes.node,
  beforeTitle: PropTypes.node,
  afterTitle: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  disableFullscreen: PropTypes.bool
};
